import { apiSports } from '@spo/services/api';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { sleep } from '../utils/sleep';

export const useSearchedSports = (search: string, debounce = false) => {
  return useQuery({
    queryKey: ['useSports', search],
    queryFn: async ({ signal }) => {
      if (debounce) {
        await sleep(500);
      }
      if (!signal?.aborted) {
        const response = await apiSports.getSports({
          searchInput: search,
          sportIds: [],
          language: 'EN',
          page: 0,
          size: 30,
        });
        return response;
      }
    },
    placeholderData: keepPreviousData,
  });
};

export const useSportsByIds = (sportIds: number[], debounce = false) => {
  return useQuery({
    queryKey: ['useSportsByIds', sportIds],
    queryFn: async ({ signal }) => {
      if (debounce) {
        await sleep(800);
      }
      if (!signal?.aborted && sportIds.length) {
        const response = await apiSports.getSports({
          searchInput: '',
          sportIds,
          language: 'EN',
          page: 0,
          size: 30,
        });
        return response;
      }
    },
    refetchOnWindowFocus: false,
  });
};
